import { Flex, IconDotgainFill } from '@gmg/gmg-react-components';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModuleLicense } from 'src/viewModels/Organization';
import OrganizationContainer from '../OrganizationContainer';
import ProductsTable from './ProductManagementTable';

export interface ProductsManagementProps { };

const ProductsManagement: FunctionComponent<ProductsManagementProps> = () => {
    const { t } = useTranslation();
    const [productList, setProductList] = useState<Array<ModuleLicense> | undefined>(undefined);
    const isProductListLoading = productList === undefined;

    return (
        <OrganizationContainer
            onOrganizationLoad={(organization) => {
                const products = Array.from(organization.moduleLicenses.modules.values())
                    .filter(details => details.contractStatus.hasContract);
                setProductList(products);
            }}
            viewInfo={{
                icon: <IconDotgainFill width={16} height={16} />,
                label: t('HeaderPageTitles.product_management_title', 'Product Management'),
            }}
        >
            <Flex flexDirection='column'>
                {isProductListLoading
                    ? <></>
                    // Quick fix not to see the spinner 'cos at that point we have already fetched the data
                    // and there is actually no loading state but react needs a tiny amount of time to update the ui
                    // React.suspense should be introduced with fallback UI
                    : <ProductsTable productList={productList} />
                }
            </Flex>
        </OrganizationContainer>
    );
};


export default ProductsManagement;